import FormatDate from 'Assets/js/dateformatter';

function stringToArray(value) {
  let array = [];
  if (value.indexOf(',') !== -1) {
    array = value.split(',');
  } else if (value !== '') {
    array = [value];
  } else {
    array = [];
  }
  return array;
}

function arrayToString(value) {
  if (typeof value === 'object') {
    return value.join(',');
  }
  return value;
}

function objectToArray(data, obj) {
  const arr = [];
  Object.keys(obj).forEach((key) => {
    arr.push({
      value: obj[key],
      label: obj[key],
      children: (() => {
        if (data[key]) {
          return objectToArray(data, data[key]);
        }
        return [];
      })(data, key),
    });
  });
  return arr;
}

// 获取cookie
function getCookie(name) {
  const reg = new RegExp(`(^| )${name}=([^;]*)(;|$)`);
  const arr = document.cookie.match(reg);
  if (arr) {
    return (arr[2]);
  }
  return null;
}

// 设置cookie,增加到vue实例方便全局调用
function setCookie(cName, value, expireDays) {
  const exDate = new Date();
  exDate.setDate(exDate.getDate() + expireDays);
  document.cookie = `${cName}=${escape(value)}${((expireDays === null) ? '' : `;expires=${exDate.toGMTString()}`)}`;
}

// 删除cookie
function delCookie(name) {
  const exp = new Date();
  exp.setTime(exp.getTime() - 1);
  const cookieValue = getCookie(name);
  if (cookieValue !== null) {
    document.cookie = `${name}=${cookieValue};expires=${exp.toGMTString()}`;
  }
}

// 从浏览器地址获取参数
function getParamFromUrl(name) {
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, 'i');
  const r = window.location.search.substr(1).match(reg);
  if (r !== null) return decodeURIComponent(r[2].replace(/\+/g, '+'));
  return null;
}

// 从字符串获取参数
function getParam(name, string) {
  const reg = new RegExp(`(^|[&,?])${name}=([^&]*)(&|$)`, 'i');
  const r = decodeURIComponent(string).match(reg);
  if (r !== null) return decodeURIComponent(r[2].replace(/\+/g, '+'));
  return null;
}

function sortLikeWin(v1, v2, fieldName = 'fileName') {
  let a = v1[fieldName];
  let b = v2[fieldName];
  const reg = /[0-9]+/g;
  const lista = a.match(reg);
  const listb = b.match(reg);
  if (!lista || !listb) {
    return a.localeCompare(b);
  }
  for (let i = 0, minLen = Math.min(lista.length, listb.length); i < minLen; i += 1) {
    // 数字所在位置序号
    const indexa = a.indexOf(lista[i]);
    const indexb = b.indexOf(listb[i]);
    // 数字前面的前缀
    const prefixa = a.substring(0, indexa);
    const prefixb = b.substring(0, indexb);
    // 数字的string
    const stra = lista[i];
    const strb = listb[i];
    // 数字的值
    const numa = parseInt(stra, 10);
    const numb = parseInt(strb, 10);
    // 如果数字的序号不等或前缀不等，属于前缀不同的情况，直接比较
    if (indexa !== indexb || prefixa !== prefixb) {
      return a.localeCompare(b);
    }
    // 数字的string全等
    if (stra === strb) {
      // 如果是最后一个数字，比较数字的后缀
      if (i === minLen - 1) {
        return a.substring(indexa).localeCompare(b.substring(indexb));
      }
      // 如果不是最后一个数字，则循环跳转到下一个数字，并去掉前面相同的部分
      a = a.substring(indexa + stra.length);
      b = b.substring(indexa + stra.length);
    } else if (numa === numb) {
      // 如果数字的string不全等，但值相等
      // 直接比较数字前缀0的个数，多的更小
      return strb.lastIndexOf(`${numb}`) - stra.lastIndexOf(`${numa}`);
    } else {
      // 如果数字不等，直接比较数字大小
      return numa - numb;
    }
  }
  return false;
}

function formatMoney(value) {
  const money = value || 0;
  return parseFloat(money).toFixed(2);
}

function hexToRgba(hexColor, opcity) {
  const hex = hexColor.replace('#', '');
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${opcity})`;
}

function throttle(fn, wait, options = {}) {
  let timer;
  let previous = 0;
  // eslint-disable-next-line func-names
  const throttled = function (...args) {
    const now = +new Date();
    // remaining 不触发下一次函数的剩余时间
    if (!previous && options.leading === false) previous = now;
    const remaining = wait - (now - previous);
    if (remaining < 0) {
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }
      previous = now;
      fn.apply(this, args);
    } else if (!timer && options.trailing !== false) {
      timer = setTimeout(() => {
        previous = options.leading === false ? 0 : new Date().getTime();
        timer = null;
        fn.apply(this, args);
      }, remaining);
    }
  };
  return throttled;
}


export default {
  arrayToString,
  stringToArray,
  objectToArray,
  getCookie,
  setCookie,
  delCookie,
  getParam,
  FormatDate,
  getParamFromUrl,
  sortLikeWin,
  formatMoney,
  hexToRgba,
  throttle,
};



// WEBPACK FOOTER //
// ./src/utils/index.js